"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _StatelessPanel = _interopRequireDefault(require("./StatelessPanel"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AccordionPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AccordionPanel, _Component);

  var _super = _createSuper(AccordionPanel);

  function AccordionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AccordionPanel);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "accordionPanels", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPanelsClick", function (e) {
      if (!!_this.props.expandedPanels && _this.accordionPanels && e.target) {
        var panelsNodes = Array.from(_this.accordionPanels.querySelectorAll('.panel-new'));
        var panelClickedIndex = panelsNodes.findIndex(function (panel) {
          return panel.contains(e.target);
        });
        setTimeout(function () {
          _this.setState({
            expandedPanelActive: panelClickedIndex
          });
        }, 50);
      }
    });

    if (_this.props.expandedPanels) {
      _this.state = {
        expandedAllPanels: _objectSpread({}, _this.props.expandedPanels)
      };
    } else {
      var _this$props$defaultAc;

      _this.state = {
        activePanelIndex: (_this$props$defaultAc = _this.props.defaultActivePanelIndex) !== null && _this$props$defaultAc !== void 0 ? _this$props$defaultAc : undefined
      };
    }

    _this.togglePanel = _this.togglePanel.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AccordionPanel, [{
    key: "togglePanel",
    value: function togglePanel(activeIndex) {
      var _this$props$panels;

      var showUnsavedMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (showUnsavedMessage && this.props.renderUnsavedChangesModal) {
        this.props.renderUnsavedChangesModal();
        return;
      }

      if (this.state.activePanelIndex === activeIndex) {
        this.setState({
          activePanelIndex: undefined
        });
        return;
      }

      var activePanel = (_this$props$panels = this.props.panels) === null || _this$props$panels === void 0 ? void 0 : _this$props$panels[activeIndex];

      if (this.props.expandedPanels && activePanel !== null && activePanel !== void 0 && activePanel.id) {
        var _this$state$expandedA;

        this.setState({
          expandedAllPanels: _objectSpread(_objectSpread({}, this.state.expandedAllPanels), {}, (0, _defineProperty2.default)({}, activePanel.id, !((_this$state$expandedA = this.state.expandedAllPanels) !== null && _this$state$expandedA !== void 0 && _this$state$expandedA[activePanel.id])))
        });
      } else {
        this.setState({
          activePanelIndex: activeIndex
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (previousProps.defaultActivePanelIndex !== this.props.defaultActivePanelIndex) {
        this.setState({
          activePanelIndex: this.props.defaultActivePanelIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          expandedPanels = _this$props.expandedPanels,
          panels = _this$props.panels;
      var activePanelIndex = this.state.activePanelIndex;
      if (!Array.isArray(panels)) return null;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          'all-panels-expanded': expandedPanels
        }),
        onClick: this.onPanelsClick,
        ref: function ref(el) {
          _this2.accordionPanels = el;
        }
      }, panels.map(function (panelChild, idx) {
        var _panelChild$hasUnsave, _panelChild$customCla, _panelChild$collapsib, _this2$state$expanded, _panelChild$id;

        var showUnsavedMessage = (_panelChild$hasUnsave = panelChild.hasUnsavedChanges) !== null && _panelChild$hasUnsave !== void 0 ? _panelChild$hasUnsave : false;
        var customClass = (_panelChild$customCla = panelChild.customClass) !== null && _panelChild$customCla !== void 0 ? _panelChild$customCla : '';
        var collapsible = (_panelChild$collapsib = panelChild.collapsible) !== null && _panelChild$collapsib !== void 0 ? _panelChild$collapsib : true;
        return (0, _preact.h)(_StatelessPanel.default, {
          key: idx,
          title: panelChild.title,
          newStyle: true,
          collapsible: collapsible,
          isOpen: expandedPanels ? (_this2$state$expanded = _this2.state.expandedAllPanels) === null || _this2$state$expanded === void 0 ? void 0 : _this2$state$expanded[(_panelChild$id = panelChild.id) !== null && _panelChild$id !== void 0 ? _panelChild$id : ''] : activePanelIndex === idx,
          customTogglePanel: function customTogglePanel() {
            _this2.togglePanel(idx, showUnsavedMessage);

            if (panelChild.onClick) panelChild.onClick();
            if (panelChild.onClickPanel) panelChild.onClickPanel(idx);
          },
          bodyClass: customClass,
          customClass: customClass,
          heading: panelChild.heading,
          isActivePanel: !!expandedPanels && _this2.state.expandedPanelActive === idx,
          disabled: panelChild.disabled,
          error: panelChild.error
        }, panelChild.body);
      }));
    }
  }]);
  return AccordionPanel;
}(_preact.Component);

var _default = AccordionPanel;
exports.default = _default;